import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./RateAgreementTeaser.scss";
import rateAgreementService from "../../services/RateAgreementService";
import utilService from "../../services/UtilService";
import { SPOTButton } from "spot-component-library/lib/components/SPOTButton";
import { Panel } from "spot-component-library/lib/components/basic/panel/Panel";
import CalenderIcon from "../../../resources/images/Kalender_Ratenrechner_illu.svg";

export interface RateAgreementTeaserProps {
    buttonText?: string | null;
    titleText?: string | null;
    infoText?: string | null;
    campaign?: string | null;
}

export const RateAgreementTeaser = (props: RateAgreementTeaserProps) => {
    const { t } = useTranslation();

    const [isRateAgreementPossible, setIsRateAgreementPossible] = useState<boolean>(false);

    const [infoText, setInfoText] = useState<string>();
    const [titleText, setTitleText] = useState<string>();
    const [buttonText, setButtonText] = useState<string>(t("TEASER.BUTTON_TO_RATE_AGREEMENT"));

    async function checkRateAgreementPossible() {
        const debtNumber = await utilService.getDebtNo();
        if (debtNumber) {
            const isRateAgreementPossible = await rateAgreementService.isRateAgreementAvailable(debtNumber);
            setIsRateAgreementPossible(isRateAgreementPossible);
        }
    }

    React.useEffect(() => {
        checkRateAgreementPossible();

        const buttonTextTmp = props.buttonText ? props.buttonText : t("TEASER.BUTTON_TO_RATE_AGREEMENT");
        setButtonText(buttonTextTmp);

        const infoTextTmp = props.infoText ? props.infoText : undefined;
        setInfoText(infoTextTmp);

        const titleTextTmp = props.titleText ? props.titleText : t("TEASER.TITLE");
        setTitleText(titleTextTmp);

        window.addEventListener("debtnumberchange", (e: any) => {
            rateAgreementService.isRateAgreementAvailable(e.detail.debtnumber).then((response) => {
                setIsRateAgreementPossible(response);
            });
        });
    }, []);

    const redirectAndSendEvent = () => {
        setEtRateAgreement();

        if (props.campaign) {
            window.location.href = "/services/rateagreement?cmp=" + props.campaign;
            return;
        }

        window.location.href = "/services/rateagreement";
    };

    function setEtRateAgreement() {
        try {
            // @ts-ignore
            if (typeof _etracker === "object" && et_ClickEvent !== undefined) {
                // @ts-ignore
                _etracker.sendEvent(new et_ClickEvent(et_pagename, "RateAgreementTeaser"));
            }
        } catch (e) {
            console.log("ETC error!", e);
        }
    }

    return (
        <div className={"ra-teaser-container"}>
            {isRateAgreementPossible && (
                <Panel>
                    <div className="ra-teaser-wrapper">
                        <div className={"ra-teaser-info"}>
                            <img src={CalenderIcon} alt={"CalenderIcon"} />
                            <div>
                                <div className="ra-teaser-title">{titleText}</div>
                                <div>{infoText}</div>
                            </div>
                        </div>

                        <SPOTButton onClick={() => redirectAndSendEvent()} type="ghost" label={buttonText} disabled={false} />
                    </div>
                </Panel>
            )}
        </div>
    );
};
